<template src="../templates/normal_fcont_94.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadCardPrint from '../components/AppDownloadCardPrint'

import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  data() {
    return {
      articleId: '94',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,AppDownloadCreative,AppDownloadCardPrint
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['94-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['94-2']}
    ]};

  }
};
</script>
<style >

</style>

